import { useEffect, useRef, useState } from 'react';

import invariant from 'tiny-invariant';

import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

import { useOptions } from '../../../controllers/options-provider';
import { isL1ItemData } from '../dnd-data';

export function useL1DragState() {
	const { l1DragAndDropEnabled } = useOptions();

	const groupDropIndicatorRef = useRef<HTMLDivElement | null>(null);
	const [dragState, setDragState] = useState<'idle' | 'is-over'>('idle');
	useEffect(() => {
		if (!l1DragAndDropEnabled) {
			return;
		}

		const l1GroupDropIndicator = groupDropIndicatorRef.current;
		invariant(l1GroupDropIndicator, 'l1GroupDropIndicatorRef should not be null');
		return dropTargetForElements({
			element: l1GroupDropIndicator,
			canDrop: ({ source }) => isL1ItemData(source.data),
			onDragStart() {
				setDragState('is-over');
			},
			onDragEnter() {
				setDragState('is-over');
			},
			onDragLeave() {
				setDragState('idle');
			},
			onDrop() {
				setDragState('idle');
			},
		});
	}, [l1DragAndDropEnabled]);

	return {
		groupDropIndicatorRef,
		dragState,
	};
}
